export const createSuspensePromise = <T>(promiseFunction: () => Promise<T>) => {
  let status = 'pending';
  let result;

  const suspender = promiseFunction().then(
    (res) => {
      status = 'success';
      result = res;
    },
    (err) => {
      status = 'error';
      result = err;
    },
  );

  return {
    read() {
      if (status === 'pending') {
        throw suspender;
      } else if (status === 'error') {
        throw result;
      } else if (status === 'success') {
        return result;
      }
    },
  };
};
